import { DocumentType, ProcessingStatus } from '@/types/job.types';
import { formatDate, isValidDate } from '@/utils/date';

interface JobDocumentLike {
  documentType: string | null;
  processingStatus: string | null;
}

/** True when a completed job_description document is available to download. */
export function hasReadyUploadedJobDescription(
  documents: JobDocumentLike[] | undefined | null,
): boolean {
  return Boolean(
    documents?.some(
      (d) =>
        d.documentType === DocumentType.JOB_DESCRIPTION &&
        d.processingStatus === ProcessingStatus.COMPLETED,
    ),
  );
}

/**
 * Prefer updatedAt, fall back to createdAt. Returns null when missing or unparseable
 * so callers never show "Invalid date" / N/A in the PDF menu hint.
 */
export function resolveJobOfferLastUpdatedDate(
  updatedAt?: string | null,
  createdAt?: string | null,
): string | null {
  const dateSource = updatedAt || createdAt;
  if (!dateSource || !isValidDate(dateSource)) return null;
  return formatDate(dateSource);
}

export const JOB_OFFER_PDF_GENERATION_FAILED = 'job_offer_pdf_generation_failed';

export function isJobOfferPdfGenerationFailure(message: string | undefined | null): boolean {
  return Boolean(message?.includes(JOB_OFFER_PDF_GENERATION_FAILED));
}

/** Toast i18n key for a failed job-offer PDF download (generation vs generic). */
export function jobOfferPdfDownloadErrorToastKey(
  message: string | undefined | null,
): 'toasts.job_offer_pdf_generation_failed' | 'toasts.job_offer_pdf_download_failed' {
  return isJobOfferPdfGenerationFailure(message)
    ? 'toasts.job_offer_pdf_generation_failed'
    : 'toasts.job_offer_pdf_download_failed';
}
